module.exports = __webpack_public_path__ + "static/media/Goodra_gaussian2.a7efbf6c.png";